import { useProfile } from '@/hooks/useProfile';
import { PROFILE_MR_EMPLOYEE_SUBTABS, PROFILE_PUBLIC_SUBTABS, TABS } from './navbar-data';
import { NavbarCreateAccountButton } from './NavbarCreateAccountButton';
import { NavbarLoginButton } from './NavbarLoginButton';
import { NavbarLogo } from './NavbarLogo';
import { NavbarProfile } from './NavbarProfile';
import { NavbarTabs } from './NavbarTabs';
interface NavbarDesktopProps {
  isAuthenticated: boolean;
}

export const NavbarDesktop = ({ isAuthenticated }: NavbarDesktopProps) => {
  const { isMarshallReddickEmployee } = useProfile();

  return (
    <nav className="navbar navbar-desktop">
      <div className="navbar-container">
        <NavbarLogo />
        <NavbarTabs tabs={TABS} isAuthenticated={isAuthenticated} />
        <span className="navbar-tabs-spacer" data-authenticated={isAuthenticated} />
        {isAuthenticated ? (
          <NavbarProfile
            subtabs={[
              ...PROFILE_PUBLIC_SUBTABS,
              ...(isMarshallReddickEmployee ? PROFILE_MR_EMPLOYEE_SUBTABS : []),
            ]}
          />
        ) : (
          <div className="navbar-auth-buttons">
            <NavbarLoginButton />
            <NavbarCreateAccountButton />
          </div>
        )}
      </div>
    </nav>
  );
};
